export default function Loading() {
	return (
		<i className="gg-spinner"></i>
	);
}